import { TinyTheme } from "src/course/domain/CourseEditModel";
import classes from "../SideBar.module.scss";
import { Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import LnIcon from "src/components/LnIcon";
import courseService from "src/course/CourseService";
import PartCard from "./PartCard";

import { useSortable, SortableContext } from "@dnd-kit/sortable";
import { CSS } from '@dnd-kit/utilities';
import PartCardDummy from "./PartCardDummy";
import { urlService } from "src/services/NavService";
import { Link } from "react-router-dom";
import React, { useCallback } from "react";

export default function ThemeCard(props: { readOnly: boolean, dragged?: boolean, theme?: TinyTheme, currentThemeId?: string, currentPartId?: string, currentCourseId: string }) {

    const { theme, currentPartId, currentThemeId, currentCourseId, dragged, readOnly } = props;

    

    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: theme!.Id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: dragged ? "75%" : ""
    };

    // The link does the navigating; the click only opens or closes the theme's parts.
    const themeClick = useCallback( (themeId: string) => {

        courseService.toggleThemeOpen(currentCourseId!, themeId, !!currentPartId || currentThemeId !== themeId);

    }, [currentThemeId, currentPartId, currentCourseId] );
    
  

    if (!theme) return null;

    return <div ref={setNodeRef} key={theme.Id} id={theme.Id} style={style}>
        <Card className={[classes.theme, "border border-primary"].join(' ')}>
            <CardHeader className={((!currentPartId && theme.Id === currentThemeId) ? classes.selected + " " : "") + classes.header + " pb-2 px-1 pt-0"} >

                {/* The name is the link, focusable and reachable by keyboard like the part
                    rows below it. `stretched-link` spreads its click area over the header
                    (`.header` is position: relative), as the arrow cell was clickable too;
                    the drag handle is lifted above it with z-2 so it keeps working. */}
                <table >
                    <tbody>
                        <tr>
                            <td>
                                <div>
                                    {!readOnly &&
                                        <div className="ns-drag-cursor position-relative z-2" {...attributes} {...listeners}>
                                            <LnIcon name="book" className="me-2 mt-2" />
                                        </div>
                                    }
                                    {readOnly &&
                                        <LnIcon name="book" className="me-2 mt-2" />
                                    }
                                </div>
                            </td>

                            <td className="ps-2 pointer">
                                <Link to={urlService.urlToTheme(currentCourseId, theme.Id)} state={{ readOnly }}
                                    onClick={() => themeClick(theme.Id)} draggable={false} aria-expanded={!!theme.Open}
                                    className={`stretched-link d-block link-plain ${classes.themename} word-break-word`}>
                                    {theme.Name}
                                </Link>
                            </td>

                            <td className={`${classes.indicator} pointer`}>
                                <LnIcon name="right-arrow" className={theme.Open ? classes.down : ""} />
                            </td>

                        </tr>
                    </tbody>
                </table>


            </CardHeader>
            <Collapse isOpen={theme.Open}>
                <CardBody className={classes.parts}>
                    <SortableContext items={theme.Parts.map(l => l.Id)} id={theme.Id}>
                        {
                            theme.Parts.map((p) => (
                                <PartCard readOnly={readOnly} key={p.Id} part={p} partId={currentPartId} theme={theme} currentCourseId={currentCourseId} />
                            ))
                        }
                        {(!theme.Parts || theme.Parts.length === 0) &&
                            <PartCardDummy partId={`dummypart_${theme.Id}`} />
                        }
                    </SortableContext>
                </CardBody>
            </Collapse>
        </Card >
    </div>

}